import { FETCH_TOKENINSTANCE,FETCH_REVOKEINSTANCE } from "../actions/types";
const initialState = {
    tokenInstance:{},
    revokeInstance: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_TOKENINSTANCE:
      return {
        ...state,
        tokenInstance: action.payload
      };
    case FETCH_REVOKEINSTANCE:
      return {
        ...state,
        revokeInstance: action.payload
      };
    default:
      return state;
  }
}
